module.exports = __webpack_public_path__ + "img/block02.71ff3c7b.webp";